<template>
  <div v-resize:debounce.100="onResize">
    <div class="statistics">
      <MainMenu />
      <FullScreenLoader v-if="loading" />
      <div class="container custom" v-if="!loading">
        <!-- screen resize component -->
        <div class="row charts-wrapper">
          <div class="col-lg-6 col-chart first">
            <div class="chart-header-wrapper">
              <h3 class="chart-title">Total Population Vaccination</h3>
              <span class="total-amount">Total: {{ chartDataTotalAmount }}</span>
            </div>

            <PieChart :chartdata="chartDataTotal" :options="options" :legendPosition="options.legend.position" />
          </div>
          <div class="col-lg-6 col-chart">
            <div class="chart-header-wrapper">
              <h3 class="chart-title">Total Population Vaccination 60+</h3>
              <span class="total-amount">Total: {{ chartDataTotal60PlusAmount }}</span>
            </div>
            <PieChart :chartdata="chartDataTotal60Plus" :options="options" :legendPosition="options.legend.position" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainMenu from '@/components/main-menu.vue';
import PieChart from './components/pie-chart.vue';
import FullScreenLoader from '@/components/fullscreen-loader.vue';
import axios from 'axios';
import resize from 'vue-resize-directive';

export default {
  directives: { resize },
  name: 'Statistics',
  components: {
    MainMenu,
    PieChart,
    FullScreenLoader,
  },
  data() {
    return {
      baseUrlApi: null,
      loading: true,
      chartDataTotal: {},
      chartDataTotal60Plus: {},
      chartDataTotalAmount: 100,
      chartDataTotal60PlusAmount: null,
      options: {
        maintainAspectRatio: false,
        legend: {
          position: 'right',
          labels: {
            fontSize: 20,
            padding: 20,
          },
        },
      },
    };
  },
  async mounted() {
    this.getPieChartData();
  },
  methods: {
    async getPieChartData() {
      try {
        let total = await axios.get(`${this.$baseUrlApi}/healthcheck-restful-api/public/population/total`);
        total = this.sortObj(total.data);
        let total60Plus = await axios.get(`${this.$baseUrlApi}/healthcheck-restful-api/public/population/60`);
        total60Plus = this.sortObj(total60Plus.data);
        this.setData('chartDataTotal', total, 'chartDataTotalAmount');
        this.setData('chartDataTotal60Plus', total60Plus, 'chartDataTotal60PlusAmount');
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    setData(dataObject, data, totalAmount) {
      //this[totalAmount] = data.filter((item) => item[0] !== '2nd Vaccine taken').reduce((a, b) => a + b[1], 0);
      this[totalAmount] = data.reduce((a, b) => a + b[1], 0);
      this[dataObject] = {
        labels: data.map((item) => item[0] + ' ( ' + item[1] + ' ) '),
        datasets: [
          {
            backgroundColor: ['#4075D4', '#009EED', '#00C0DF', '#00DBB6'], //#8AEE88, #F9F871
            data: data.map((item) => item[1]),
          },
        ],
      };
    },
    onResize() {
      let width = window.innerWidth;
      if (width < 1200) {
        this.options.legend.position = 'bottom';
      } else {
        this.options.legend.position = 'right';
      }
    },
    sortObj(dataObj) {
      let sortedObj = dataObj.sort((a, b) => {
        if (a[0] < b[0]) return -1;
        if (a[0] > b[0]) return 1;
        return 0;
      });
      return sortedObj;
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/_variables.scss';
.statistics {
  .container.custom {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 100px;
  }
  .charts-wrapper {
    min-height: 80vh;
    border: 1px solid lighten(lightgrey, 5%);
    border-radius: 60px;
    padding: 30px 20px;
    margin-top: 60px;
    .col-chart {
      flex-direction: column;
      justify-content: center;
      display: flex;
    }
    .chart-header-wrapper {
      margin-bottom: 30px;
      .chart-title {
        color: grey;
      }
      .total-amount {
        font-size: 20px;
        border: 1px solid $primary;
        display: inline-block;
        padding: 3px 20px;
        border-radius: 50px;
        color: $primary;
        font-weight: 500;
      }
    }
  }
}

/* Medium Devices, Desktops */
@media only screen and (max-width: 992px) {
  .charts-wrapper {
    .col-chart.first {
      margin-bottom: 60px;
    }
  }
}

// sm
@media (max-width: 767.98px) {
  .statistics {
    .container.custom {
      padding: 0 0px;
      .charts-wrapper {
        border: none;
      }
    }

    .charts-wrapper {
      margin-top: 0px;
      margin-bottom: 30px;
    }
  }
}
</style>
